/**
 * Format phone numbers for display
 * USA numbers: 732-800-1313 (10 digits with dashes)
 * International: +countrycode-999-999-9999
 */
export const formatPhone = (phone) => {
  if (!phone) return '';
  
  // Remove all non-digit characters except leading +
  const hasPlus = phone.startsWith('+');
  const digits = phone.replace(/\D/g, '');
  
  if (!digits) return phone;
  
  // USA number (10 digits or 11 digits starting with 1)
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  
  // USA number with country code (11 digits starting with 1)
  if (digits.length === 11 && digits.startsWith('1')) {
    return `${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  
  // International number
  if (digits.length > 10) {
    // Assume first 1-3 digits are country code
    let countryCode, remaining;
    
    if (digits.startsWith('1')) {
      // North America (+1)
      countryCode = '1';
      remaining = digits.slice(1);
    } else if (digits.length >= 12) {
      // Longer numbers - assume 2-digit country code
      countryCode = digits.slice(0, 2);
      remaining = digits.slice(2);
    } else {
      // Default - assume 2-digit country code
      countryCode = digits.slice(0, 2);
      remaining = digits.slice(2);
    }
    
    // Format remaining digits as XXX-XXX-XXXX or similar
    if (remaining.length === 10) {
      return `+${countryCode}-${remaining.slice(0, 3)}-${remaining.slice(3, 6)}-${remaining.slice(6)}`;
    } else if (remaining.length > 6) {
      const mid = Math.ceil(remaining.length / 2);
      const part1 = remaining.slice(0, 3);
      const part2 = remaining.slice(3, 6);
      const part3 = remaining.slice(6);
      return `+${countryCode}-${part1}-${part2}-${part3}`;
    } else {
      return `+${countryCode}-${remaining}`;
    }
  }
  
  // Short numbers - return as-is with dashes if possible
  if (digits.length === 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  
  // Return original if we can't format it
  return phone;
};

export default formatPhone;
